import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IOption } from 'types'

interface IAppToolBubble {
  category: IOption
  selectedBubble: string
  index: number
  handleBubbleSelection: (p) => void
}

export const AppToolBubble: FC<IAppToolBubble> = ({
  category,
  selectedBubble,
  index,
  handleBubbleSelection,
}) => {
  const { t } = useTranslation()
  const localizedLabel = category.value
    ? t(`tools.categories.${category.value}.label`, { defaultValue: category.label })
    : category.label
  return (
    <div
      key={index}
      className={`border ${
        category.value === selectedBubble
          ? 'bg-blue-lighter2x border-primary-brandBlueLight'
          : 'border-primary-disabled'
      } px-4 py-1.5 rounded-full text-silver text-sm font-medium w-fit cursor-pointer whitespace-nowrap`}
      onClick={() => handleBubbleSelection(category.value)}
    >
      {localizedLabel}
    </div>
  )
}
